import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = "Siden blev ikke fundet - Johanne Eis";
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center space-y-8">
      <div className="space-y-4">
        <span className="text-brand-rose text-xs font-semibold tracking-widest uppercase font-sans">Fejl 404</span>
        <h1 className="text-5xl sm:text-6xl text-brand-dark tracking-wide font-display">
          Siden blev ikke fundet
        </h1>
        <p className="text-brand-muted font-sans text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Du kan altid vende tilbage til forsiden eller udforske mine kommende events.
        </p>
      </div>
      <div className="flex justify-center gap-4 pt-4">
        <Link
          to="/"
          className="bg-brand-green hover:bg-brand-green/90 text-brand-cream px-6 py-3 rounded-full text-sm font-medium tracking-wide transition-all duration-300 shadow-sm"
        >
          Gå til forsiden
        </Link>
        <Link
          to="/events"
          className="bg-brand-cream hover:bg-brand-sand border border-brand-beige text-brand-dark px-6 py-3 rounded-full text-sm font-medium tracking-wide transition-all duration-300"
        >
          Se events
        </Link>
      </div>
    </div>
  );
}
